import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { useRoomChains } from '@/hooks/useRoomChains';
import { getRoomById } from '@/data/rooms';
import { Link2, Check, Award } from 'lucide-react';

const RoomChains = () => {
  const { t } = useLanguage();
  const { chains } = useRoomChains();

  return (
    <div className="space-y-4">
      <h2 className="text-xs uppercase tracking-widest text-muted-foreground/40 flex items-center gap-2">
        <span className="w-1 h-1 rounded-full bg-muted-foreground/20" />
        <Link2 className="w-3 h-3" /> {t('room_chains') || 'Room Chains'}
      </h2>
      <div className="grid sm:grid-cols-3 gap-4">
        {chains.map((chain) => (
          <div key={chain.id} className={`p-4 border rounded-xl transition-all ${chain.isComplete ? 'border-primary/30 bg-primary/5' : 'border-border/20'}`}>
            <div className="flex items-center gap-2 mb-3">
              {chain.isComplete && <Award className="w-4 h-4 text-primary" />}
              <h3 className="text-sm font-light">{t(chain.nameKey) || chain.id}</h3>
            </div>
            <div className="space-y-2">
              {chain.rooms.map((roomId) => {
                const room = getRoomById(roomId);
                const isCompleted = chain.completed.includes(roomId);
                return (
                  <Link key={roomId} to={`/room/${roomId}`} className={`flex items-center gap-2 text-xs transition-colors ${isCompleted ? 'text-primary/70' : 'text-muted-foreground/40 hover:text-muted-foreground'}`}>
                    {isCompleted ? <Check className="w-3 h-3" /> : <span className="w-3 h-3 border border-current rounded-full" />}
                    {t(`room_${roomId}`) !== `room_${roomId}` ? t(`room_${roomId}`) : room?.title || roomId}
                  </Link>
                );
              })}
            </div>
            <div className="mt-3 h-1 bg-border/20 rounded-full overflow-hidden">
              <div className="h-full bg-primary/40 transition-all" style={{ width: `${chain.progress * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomChains;
